// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishLists-wishListPadding-oE3Ah {
    padding: 42px 0px 42px 0px;
}`, "",{"version":3,"sources":["webpack://./src/routes/wishLists/WishLists.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B","sourcesContent":[".wishListPadding {\n    padding: 42px 0px 42px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wishListPadding": `WishLists-wishListPadding-oE3Ah`
};
module.exports = ___CSS_LOADER_EXPORT___;
